namespace GeniuzPOS.ReportMasterData {
    export class Report_1303Columns {
        static columnsKey = 'ReportMasterData.Report_1303';
    }
}
